<template>
  <div>
    <h1>Training sessions</h1>
  </div>
</template>

<script>
export default {
    name: 'TeamSessions',
    async mounted () {

    }
}
</script>

<style scoped>

</style>